import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: "I've never really coached before. Is this too advanced for me?",
  a: 'It is built for exactly that. Volume 1 walks you through the practice routine and your first weeks, and Bonus 1 — The Rookie Coach Primer — teaches the positions, terms and rules in one evening, in plain English.'
}, {
  q: 'What formats and ages does it cover?',
  a: 'Flag 5v5 and 7v7, plus youth tackle, roughly ages 6 to 14, including new girls’ flag programs. Every card notes how to adapt it to your league’s player count, field size and rules.'
}, {
  q: 'Is it safe? Does it follow the rules?',
  a: 'The tackle material is progressive and always points you back to your league’s own rules and certification. You verify what is legal and age-appropriate for your setting before you run it. It is coaching material, not medical or injury-prevention advice, and it makes no promises about results.'
}, {
  q: 'Is it printable or digital?',
  a: 'Digital PDFs, laid out to print. Most coaches print the card for the day and coach from a clipboard — no app, no login, nothing to open on the field.'
}, {
  q: "Isn't there already a ton of free stuff online?",
  a: 'There are plenty of loose drills and single plays for free. What they don’t give you is the season in order — week by week, by format and age, every practice built the same way with The 4-Quarter Practice so the kids learn the routine.'
}, {
  q: "Will it fit my league's rules and player count?",
  a: 'Yes. Plans adapt to 5v5, 7v7 and tackle, and to 45, 60 or 90-minute practices. Each one tells you what to change; you confirm the specifics for your league.'
}, {
  q: 'How do I get it?',
  a: 'Instant PDF download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-white text-ink" data-id="element-74" data-mp="1uhct1lsty6c7">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-75" data-mp="1pq4iunjoegxz">
        <div className="text-center" data-id="element-76" data-mp="1potdwkehv35a">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-77" data-mp="1kqrwe3wpvbvx">
            Before you buy
          </p>
          <h2 id="faq-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-78" data-mp="1fsztyfyg47dh">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-79" data-mp="28hx7k5rppfzw">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-xl border border-ice-dark bg-white" data-id="element-80" data-mp="1zfxtnmbzus16" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-deep" data-id="element-81" data-mp="s35fjtyhaar4">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-82" data-mp="38mpoa5hp9tyn" /> : <PlusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-83" data-mp="3iec7ao0a4xby" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-84" data-mp="90nd5umr5xp">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}